import axios from "axios";

export const uploadS3 = async (imageFile, signedRequestUrl) => {
  let instance = axios.create();
  instance.defaults.headers.common = {}; // prevent automatic bearer token
  await instance.put(signedRequestUrl, imageFile, {
    headers: { "Content-Type": imageFile.type },
  });
};
